import { AiOutlineCloudServer } from 'react-icons/ai'
import { TbAppWindowFilled } from 'react-icons/tb'
import { FaMoneyBillTrendUp } from 'react-icons/fa6'
import { IoIosPricetags } from 'react-icons/io'
import { MdAccountBalanceWallet } from 'react-icons/md'
import { FaChartBar } from "react-icons/fa"
import { IoMdPaper } from "react-icons/io"
import { FaRegCreditCard } from "react-icons/fa6"

export const configMenu = [
  {
    label: 'openStackServices',
    value: 'openstack_services',
    icon: <AiOutlineCloudServer size={32} />,
  },
  {
    label: 'userInterfaces',
    value: 'user_interfaces',
    icon: <TbAppWindowFilled size={32} />,
  },
  {
    label: 'billingService',
    value: 'billing_service',
    icon: <FaMoneyBillTrendUp size={26} />,
  },
]

export const accountingMenu = [
  {
    label: 'prices',
    value: 'prices',
    icon: <IoIosPricetags size={30} />,
  },
  {
    label: 'accounts',
    value: 'accounts',
    icon: <MdAccountBalanceWallet size={32} />,
  },
  {
    label: 'billing',
    value: 'billing',
    icon: <FaChartBar size={26} />,
  },
  {
    label: 'invoices',
    value: 'invoices',
    icon: <IoMdPaper size={26} />,
  },
  {
    label: 'payments',
    value: 'payments',
    icon: <FaRegCreditCard size={26} />,
  },
]